import { Theme } from "../../../../components/constants";

export default {
    container: {
        marginTop: "30px",

    },
    selectedLabelsStyle: {
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        alignItems: "baseline",
    },
    headingCustomStyles: {
        marginBottom: 0,
    },
    actionButtonsDiv: {
        display: "flex",
        flexDirection: "row",
        gap: "10px",
    },
    btnColorRed: {
        background: Theme.DANGER,
    },
    btnColorGreen: {
        background: Theme.SUCCESS,
    },
    proceedToPaymentBtnDiv: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
    },
    scheduleDateDiv: {
        width: "250px"
    },
}